'use strict';

var numeral = require('numeral'),
    moment = require('moment');

function monthDiff(date1, date2) {
	var moment1 = moment(date1);
	var moment2 = moment(date2);

	if (moment1.isAfter(moment2)) {
		return monthDiff(date2, date1);
	}

	// Now we are ensured that moment1 is before or same as moment2
	var months = moment2.month() - moment1.month();
	var years = moment2.year() - moment1.year();

	return years * 12 + months;
}

module.exports = {
	patchMissingDates: function patchMissingDates(rows) {
		// Fill in gaps in stats rows where user didn't get any hits
		var last;
		var ONE_DAY = 24 * 60 * 60 * 1000;
		if (rows.length < 7 && rows.length > 1) {
			for (var i = 0; i < rows.length; i++) {
				if (last && Date.parse(rows[i].date) - last > ONE_DAY) {
					rows.splice(i, 0, { cachedHits: 0, totalHits: 0, date: new Date(ONE_DAY + last) });
				}
				last = Date.parse(rows[i].date);
			}
		} else if (rows.length == 1) {
			last = Date.parse(rows[0].date);
		}
		// Fill dates in up to today
		while (last < Date.now() - ONE_DAY) {
			rows[rows.length] = { cachedHits: 0, totalHits: 0, date: new Date(ONE_DAY + last) };
			last += ONE_DAY;
		}
		return rows;
	},

	formatCurrency: function formatCurrency(amountInCents, options) {
		options = options || {};

		if (options.showCents) {
			return numeral(amountInCents / 100).format('$0,0.00');
		}

		return numeral(amountInCents / 100).format('$0,0[.]00');
	},

	formatNumber: function formatNumber(num) {
		return numeral(num).format('0,0');
	},

	formatDate: function formatDate(date) {
		return moment(date).format('MMM Do, YYYY');
	},

	monthDiff: monthDiff,

	extractHostname: function extractHostname(url) {
		var hostname;

		// Find & remove protocol (http, ftp, etc.) and get the hostname
		if (url.indexOf('://') > -1) {
			hostname = url.split('/')[2];
		} else {
			hostname = url.split('/')[0];
		}

		// Find & remove port number
		hostname = hostname.split(':')[0];

		return hostname;
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/utils.js
// module id = 53
// module chunks = 5